app.controller("OrganizationalEmployAddController", [
    "$scope", "$uibModalInstance", "Position", "params", "DocumentsService", "usSpinnerService", "toastr",
    function ($scope, $uibModalInstance, Position, params, DocumentsService, usSpinnerService, toastr) {
        $scope.positions = [];
        $scope.action = params.action;
        $scope.employee = params.employee || null;
        $scope.position = params.employee ? params.employee.positionInfo.position._id : null;

        $scope.getEmployees = function (query) {
            if (query.length < 2) {
                return [];
            }
            $scope.selected = false;
            return DocumentsService.staffList({ query: query }).then(function (data) {
                return data.docs.filter(function (usr) {
                    var el_index = _.findIndex($scope.users, function (user) {
                        return user._id === usr._id;
                    });
                    return el_index === -1;
                })
            });
        };

        Position.list({
            organization: params.unitId
        }).then(function (data) {
            $scope.positions = data.docs;
        });

        $scope.add = function () {
            DocumentsService.staffAddToOrg({
                employee: $scope.employee._id,
                position: $scope.position,
                organization: params.unitId,
                secondaryPosition: $scope.secondaryPosition
            }).then(function (result) {
                toastr.success('', 'თანამშრომელი წარმატებით დაემატა');
                $uibModalInstance.close();
                loadPage();
            }).catch(function (err) {
                if (err.status == 400) {
                    toastr.error('', err.data);
                    toastr.error('', 'თანამშრომლის გადანიშვნამდე წაშალეთ ის ძველი თანამდებობიდან');
                } else if (err.status == 403) {
                    toastr.error('', err.data.error);
                }
            });
        };

        $scope.edit = function () {
            DocumentsService.staffEditToOrg({
                employee: $scope.employee._id,
                position: $scope.position,
                organization: params.unitId,
                secondaryPosition: $scope.secondaryPosition
            }).then(function (result) {
                toastr.success('', 'თანამშრომელი რედაქტირებულია');
                $uibModalInstance.close();
                loadPage();
            }).catch(function (err) {
                if (err.status == 400) {
                    toastr.error('', 'დაფიქსირდა შეცდომა!');
                } else if (err.status == 403) {
                    toastr.error('', err.data.error);
                }
            });
        };

        $scope.remove = function (emp) {
            ConfirmModal.show({
                title: "თანამშრომლის წაშლა",
                message: "გსურთ " + employee.user.firstName + " " + employee.user.lastName + " წაშალოთ თანამშრომლების სიიდან?"
            }).result.then(function () {
                usSpinnerService.spin("root");
                DocumentsService.staffRemove({
                    employee: $scope.employee._id,
                    organization: params.unitId
                }).then(function (result) {
                    usSpinnerService.stop("root");
                    toastr.success('', 'თანამშრომელი წარმატებით წაიშალა ორგანიზაციიდან');
                    loadPage();
                }).catch(function (err) {
                    usSpinnerService.stop("root");
                    if (err.status == 400) {
                        toastr.error('', 'დაფიქსირდა შეცდომა!');
                    }
                });
            });
        };

        $scope.close = function () {
            $uibModalInstance.dismiss();
        };
    }
]);
